/** Köken portreleri ve karakter/yetenek eşlemesi (görseller: /image/select/) */
export const ORIGIN_OPTIONS = [
  {
    id: 'noble',
    grayImg: '9.png',
    colorImg: '8.png',
    characterKey: 'savasci',
    abilityKey: 'zihinsel',
    titleKey: 'originNobleTitle',
    descKey: 'originNobleDesc',
  },
  {
    id: 'darkMage',
    grayImg: '10.png',
    colorImg: '11.png',
    characterKey: 'sura',
    abilityKey: 'karabuyu',
    titleKey: 'originDarkMageTitle',
    descKey: 'originDarkMageDesc',
  },
  {
    id: 'knight',
    grayImg: '12.png',
    colorImg: '13.png',
    characterKey: 'savasci',
    abilityKey: 'fiziksel',
    titleKey: 'originKnightTitle',
    descKey: 'originKnightDesc',
  },
  {
    id: 'coachman',
    grayImg: '15.png',
    colorImg: '14.png',
    characterKey: 'sura',
    abilityKey: 'buyulu',
    titleKey: 'originCoachmanTitle',
    descKey: 'originCoachmanDesc',
  },
];

export const SELECT_IMAGE_BASE = '/image/select';

export function selectImageUrl(filename) {
  return `${SELECT_IMAGE_BASE}/${filename}`;
}
